// Design tokens ported from calendar_constants.dart

export const HOUR_HEIGHT = 60;
export const TIME_COLUMN_WIDTH = 52;
export const TIMELINE_HEIGHT = HOUR_HEIGHT * 24; // 1440
export const VIEW_TRANSITION_MS = 300;

export const CALENDAR_ACCENT = '#2196F3';
export const CURRENT_TIME_COLOR = '#EF5350';
export const GRID_LINE_COLOR = '#E0E0E0';
export const DEFAULT_EVENT_COLOR = '#2196F3';

export const EVENT_COLORS = [
  '#2196F3', // Blue
  '#EF5350', // Red
  '#66BB6A', // Green
  '#FF9800', // Orange
  '#8E24AA', // Purple
  '#26C6DA', // Cyan
  '#EC407A', // Pink
  '#78909C', // Blue Grey
];

/**
 * Convert hex color to rgba string with given alpha.
 * @param {string} hex - e.g. '#2196F3'
 * @param {number} alpha - 0..1
 */
export const colorWithOpacity = (hex, alpha) => {
  const r = parseInt(hex.slice(1, 3), 16);
  const g = parseInt(hex.slice(3, 5), 16);
  const b = parseInt(hex.slice(5, 7), 16);
  return `rgba(${r}, ${g}, ${b}, ${alpha})`;
};
